module.exports = __webpack_public_path__ + "static/media/YouGift-web.21578f6c.jpg";